import React from "react";

import { useTranslation } from "react-i18next";

import SubHeader from "../../../../components/Generic/SubHeader";
import { Content } from "./styles";

export const RoutePlannerPage = () => {
  const { t: translate } = useTranslation();

  return (
    <div>
      <SubHeader title={translate("routePlanner")}></SubHeader>
      <Content>
        <iframe src={process.env.ROUTE_PLANNER_URL} />
      </Content>
    </div>
  );
};
